import { render, staticRenderFns } from "./Tender.vue?vue&type=template&id=ba632558&scoped=true&"
import script from "./Tender.vue?vue&type=script&lang=js&"
export * from "./Tender.vue?vue&type=script&lang=js&"
import style0 from "./Tender.vue?vue&type=style&index=0&id=ba632558&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba632558",
  null
  
)

export default component.exports